import {putAll, takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {call, put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';
import {showBeError} from 'utils/show-be-error';

import {adminAction, SearchManagementAssociationsRolesAction} from '../action';

function* execute({payload}: SearchManagementAssociationsRolesAction): SagaIterator {
    yield* put(adminAction.setLoading('getRoles', true));
    const response = yield* call(Api.searchUserRolesForAssociation, {text: payload});

    if (response.isSuccess) {
        yield* put(adminAction.setManagementAssociationsRoles(response.data));
    } else {
        yield putAll(showBeError(response, t('admin')('subjectsLoading')));
    }
    yield* put(adminAction.setLoading('getRoles', false));
}

/** Runs the admin saga that searches roles for the association-management form. */
export function* searchManagementAssociationsRolesSaga(): SagaIterator {
    yield takeLatestF('admin/SEARCH_MANAGEMENT_ASSOCIATIONS_ROLES', execute);
}
